import gql from "graphql-tag";
export default {
  getAppConfigOrganization: gql`
    query {
      getAppConfigOrganization {
        id
        logoUrl
        name
      }
    }
  `,
};
